import { render, staticRenderFns } from "./CRUDAparencia.vue?vue&type=template&id=de7b859e&"
import script from "./CRUDAparencia.vue?vue&type=script&lang=js&"
export * from "./CRUDAparencia.vue?vue&type=script&lang=js&"
import style0 from "./CRUDAparencia.vue?vue&type=style&index=0&id=de7b859e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports